<template lang="pug">
  ul#accordionSidebar.navbar-nav.sidebar.sidebar-dark.accordion(v-bind:class="{active:mobileNavOpen}")
    router-link.sidebar-brand.d-flex.align-items-center.justify-content-center(to='/dashboard' )
      .sidebar-brand-icon.rotate-n-15(@click="closeMobileNav()")
        //- i.fas.fa-laugh-wink
        img.logo(src="@/assets/logo.png")
    hr.sidebar-divider.my-0
    li.nav-item.active(@click="closeMobileNav()")
      router-link.nav-link(to="/dashboard")
        div
          i.fas.fa-fw.fa-tachometer-alt
        div
          span Dashboard
    //- hr.sidebar-divider
    //- .sidebar-heading Returns
    li.nav-item(@click="closeMobileNav()")
      router-link.nav-link.collapsed(to="/dashboard/returns")
        div
          i.fas.fa-fw.fa-undo-alt
        div
          span Returns 
    //- li.nav-item
      router-link.nav-link.collapsed(to="/dashboard/refunds")
        div
          i.fas.fa-fw.fa-exchange-alt
        div
          span Refunds Being Processed
    
    li.nav-item(@click="closeMobileNav()")
      router-link.nav-link(to="/dashboard/orders")
        div
          i.fas.fa-fw.fa-box-open
        div
          span Orders
    //- li.nav-item
      .nav-link.collapsed(v-on:click='orderImportDropDown = !orderImportDropDown')
        div
          i.fas.fa-fw.fa-file-import
        div
          span Order Import
        .sidebar-collapse
          i.fas.fa-fw.fa-sort-down(v-bind:class="{show : orderImportDropDown}")
      transition(name="slide")
        .dropdown(v-show="orderImportDropDown"  )
          ul.bg-white.py-2.rounded
            div(v-for="(channel, index) in channels")
              .orderImport(v-on:click="orderImportSync(index)" v-bind:class="{active : channel.syncing}")
                i.fas.fa-fw.fa-sync-alt()
                span &nbsp; Sync {{channel.name}}
            
    li.nav-item(v-bind:class="[{activeNav : $route.path == '/dashboard/connectPlatforms'},{ activeNav : $route.path == '/dashboard/connectCarriers'}]")
      .nav-link.collapsed(v-on:click='connectDropDown = !connectDropDown')
        div
          i.fas.fa-fw.fa-network-wired
        div
          span Connections
        .sidebar-collapse
          i.fas.fa-fw.fa-sort-down(v-bind:class="{show : connectDropDown}")
      transition(name="slide")
        .dropdown(v-show="connectDropDown"  )
          ul.py-2.rounded
            li.connectionNav(@click="closeMobileNav()" )
              router-link.connect-li(to='/dashboard/connectPlatforms') 
                i.fas.fa-fw.fa-money-bill-wave 
                span &nbsp; Sales Platforms
            li.connectionNav(@click="closeMobileNav()")
              router-link.connect-li(to='/dashboard/connectCarriers') 
                i.fas.fa-fw.fa-shipping-fast
                span &nbsp; Shipping Carriers
            //- li
              router-link(to='/dashboard/widget') 
                i.fas.fa-fw.fa-tools
                span &nbsp; Widget Management
    li.nav-item(@click="closeMobileNav()")
      router-link.nav-link(to="/dashboard/returnAddresses")
        div
          i.fas.fa-fw.fa-address-card
        div
          span Return Address
    
    //- hr.sidebar-divider
    //- .sidebar-heading
      | Settings
    //- li.nav-item
      router-link.nav-link(to="/dashboard/settings")
        div
          i.fas.fa-fw.fa-cog
        div
          span Settings
    //- li.nav-item
      router-link.nav-link(to="/dashboard/support")
        div
          i.fas.fa-fw.fa-question-circle
        div 
          span Support
    //- li.nav-item
      router-link.nav-link(to="/dashboard/appSettings")
        div
          i.fas.fa-fw.fa-cog
        div
          span Application Settings
    //- li.nav-item
      router-link.nav-link(to="/dashboard/presets")
        div
          i.fas.fa-fw.fa-cog
        div
          span Presets
    
    
    //- 
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: 'DashboardSidebarNav',
  props: {

  },
  computed: mapState(['mobileNavOpen',]),
  // watch:{
  //   '$route'(){
  //     if (this.$route.path === '/dashboard/connectCarriers') {
  //       this.colorNav = true
  //     }
  //     else if(this.$route.path === '/dashboard/connectPlatforms'){
  //       this.colorNav = true
  //     }
  //     else {
  //       this.colorNav = false
  //     }  
  //   }
  // },
  data:function(){
    return{
      colorNav: false,
      connectDropDown:false,
      orderImportDropDown:false,
      channels:[
        {
          name:'Shopify',
          syncing:false,
          error:false
        },
        {
          name:'WooCommerce',
          syncing:false,
          error:false
        }
      ],
    }
  },
  methods:{
    ...mapActions(['closeMobileNav'])

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 .sidebar-brand{
   background: transparent !important;
 }
  .connect-li{
    background:transparent !important;
  }
 .activeNav{
  background:#e8f0ec;

 }
.connectionNav{
  margin-bottom:15px;
}
  #accordionSidebar, .dropdown{
    background:mintcream;
  }
  
  @keyframes spin {
    100% { transform: rotate(360deg); } 
  } 
  @keyframes ellipsis {
    to {
      width: 1.25em;    
    }
  }
  @-webkit-keyframes ellipsis {
    to {
      width: 1.25em;    
    }
  }
  
  .orderImport{
    margin-bottom:10px;
    i{
      font-size: 24px;
    }
  }
  .orderImport:hover{
    color:black;
  }
  .orderImport.active{
    color:black;
    i{
      animation:spin 3s linear infinite;
      color:green;
    }
    // span:after {
    //   overflow: hidden;
    //   display: inline-block;
    //   vertical-align: bottom;
    //   -webkit-animation: ellipsis steps(4,end) 900ms infinite;      
    //   animation: ellipsis steps(4,end) 900ms infinite;
    //   content: "\2026"; /* ascii code for the ellipsis character */
    //   width: 0px;
    // }
  }
  .slide-enter, .slide-leave-to{
    transform: scaleY(0);
  }
  .logo{
    width:100%;
  }
  .dropdown{
    transform-origin: top;
    transition: transform .2s ;
    ul{
      list-style-type: none;
    }
  }
  .sidebar-dark .nav-item.active .nav-link,
  .sidebar-dark .nav-item .nav-link, 
  .sidebar-dark .nav-item .nav-link,
  .sidebar-dark .nav-item .nav-link:active, 
  .sidebar-dark .nav-item .nav-link:focus, 
  .sidebar-dark .nav-item .nav-link:hover,
  .sidebar-dark .nav-item .nav-link i{
    // color:black; 
    color:#172b4d;
    font-size:24px;
  }
  .sidebar .sidebar-brand{
    padding:3.5rem 1rem;
    margin-bottom:50px;
    z-index: 0;
  }
  .sidebar .nav-item .nav-link span{
    font-size:18px;
  }
  .sidebar .nav-item .nav-link i{
    font-size:24px;
  }
  .sidebar .nav-item .nav-link{
    display: flex;
  }  
  .sidebar-collapse i{
    transform: rotate(-90deg);
    transition: transform .2s;
  }
  .sidebar-collapse i.show{
    transform: rotate(0deg);
  }
  .sidebar .nav-item.active .nav-link{
    font-weight:400;
  }
  @media all and (max-width:768px ) {
    #accordionSidebar{
      width:65%;
      position: fixed;
      left: -100%;
      background:mintcream;
      // z-index: 2; // NOTE: this makes the UFO fly
      transition: left .3s;
      box-shadow:3px 0px 13px 0px rgba(58,59,69,.15);
      z-index: 12;

    }
    #accordionSidebar.active{
      transition: left .3s;
      left:0%;
    }
    .sidebar .nav-item .nav-link{
      width:100%;
    }
    // .mobileNavBg{
    //   width:100%;
    //   height:100vh;
    //   position: fixed;
    //   top:0;
    //   left:0;
    //   // background:pink;
    //   z-index: -1;
    // }
  }

  // active nav color #e8f0ec
</style>
